// 该 store 用于缓存系统中的公共数据 例如 采购分公司等数据
import http from '@/http/index'
import {POST_LEVEL,POST_LEVEL_CODE} from "@/utils/commonConfig";

const state = {
  //员工缓存列表
  employee_list:null,
  //职务列表
  post_data:null,
  //职务属性列表
  post_attribute:null,

}

const mutations = {

  //缓存员工数据
  SET_EMPLOYEE_LIST:(state,data)=>{
    state.employee_list = data
  },

  //缓存职务列表
  SET_POST_DATA:(state,data)=>{
    state.post_data=data
  },

  //缓存职务属性
  SET_POST_ATTRIBUTE:(state,data)=>{
    state.post_attribute=data
  }


}

const actions = {

  //获取所有职务属性
  getPostAttribute({state,commit}){
    return new Promise((resolve, reject)=>{
      if (state.post_attribute === null||state.post_attribute.length===0) {
        http.api('selectPostAndAttribute',{'name':'post_attribute'})
          .then(res => {
            commit('SET_POST_ATTRIBUTE', res.data)
            resolve(res.data)
          })
          .catch(() => {
            reject([])
          })
      } else {
        resolve(state.post_attribute)
      }
    })

  },

  //获取部门列表
  getPostsList({state,commit},level){
    const that =this;
    return new Promise((resolve, reject) => {
      if (state.post_data === null||state.post_data.length===0) {
        http.api('selectPostAndAttribute',{'name':'post_name'})
          .then(res => {
            let list = res.data;
            commit('SET_POST_DATA', list)

            let datas=[];
            if(level==POST_LEVEL_CODE.LEVEL_JU){
              datas= list.filter(item => item.post_level == POST_LEVEL.LEVEL_JU);
            }else{
              datas=list.filter(item => item.post_level != POST_LEVEL.LEVEL_JU);
            }
            resolve(datas)
          })
          .catch(() => {
            reject([])
          })
      } else {
        let datas=[];
        if(level==POST_LEVEL_CODE.LEVEL_JU){
          datas= state.post_data.filter(item => item.post_level == POST_LEVEL.LEVEL_JU);
        }else{
          datas=state.post_data.filter(item => item.post_level != POST_LEVEL.LEVEL_JU);
        }
        resolve(datas)
      }
    })
  },

  getPosts(list, level){
    if(level==POST_LEVEL_CODE.LEVEL_JU){
       return  list.filter(item => item.post_level == POST_LEVEL.LEVEL_JU);
    }else{
      return  list.filter(item => item.post_level != POST_LEVEL.LEVEL_JU);
    }
    return [];
  },

  //获取员工数据
  getEmployeeList({state, commit}){
    return new Promise((resolve, reject) => {
      if (state.employee_list === null||state.employee_list.length===0) {
        http.api('selectEmployee',{})
          .then(res => {
            commit('SET_EMPLOYEE_LIST', res.data)
            resolve(state.employee_list)
          })
          .catch(() => {
            reject([])
          })
      } else {
        resolve(state.employee_list)
      }
    })
  },



}

export default {
  state,
  mutations,
  actions
}
